// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import log from "../../../../logging";
import { AuthState } from "../../../../types";
import { AuthStatus } from "../../../../enums";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const AppStream: any;
const APPSTREAM_DIV_ID = "appstream-container";

interface Props {
  endpoint: string;
  onSignOut: (authState: AuthState) => void;
}

const EmbeddedStreamer = (props: Props): JSX.Element => {
  const { endpoint, onSignOut } = props;

  useEffect(() => {
    const appstreamOptions = {
      sessionURL: endpoint,
      userInterfaceConfig: {},
    };

    const updateSessionStateCallback = (event) => {
      log.logMessage("updateSessionState event: " + JSON.stringify(event));
      // Sign out when the session is ended.
      // See event detail in https://tiny.amazon.com/nppg2ccj/docsawsamazappslatedeveembe.
      if (
        event.sessionStatus ===
        AppStream.Embed.SessionStatus[AppStream.Embed.SessionStatus.Ended]
      ) {
        log.logMessage("User ended the session. Signing out.");
        onSignOut({ authStatus: AuthStatus.SIGNING_OUT });
      }
    };

    const updateUserInterfaceStateCallback = (event) => {
      log.logMessage(
        "updateUserInterfaceState event: " + JSON.stringify(event)
      );
    };

    const errorCallback = (event) => {
      log.logMessage("appstreamEmbedError event: " + JSON.stringify(event));
    };

    const appstreamEmbed = new AppStream.Embed(
      APPSTREAM_DIV_ID,
      appstreamOptions
    );
    appstreamEmbed.addEventListener(
      AppStream.Embed.Events.SESSION_STATE_CHANGE,
      updateSessionStateCallback
    );
    appstreamEmbed.addEventListener(
      AppStream.Embed.Events.SESSION_INTERFACE_STATE_CHANGE,
      updateUserInterfaceStateCallback
    );
    appstreamEmbed.addEventListener(
      AppStream.Embed.Events.SESSION_ERROR,
      errorCallback
    );
  }, [endpoint, onSignOut]);

  return <div className="appstream-container" id={APPSTREAM_DIV_ID} />;
};

EmbeddedStreamer.propTypes = {
  endpoint: PropTypes.string.isRequired,
};

export default EmbeddedStreamer;
